export default "__VITE_ASSET__baf9b44d__"